const nombreCliente = [
    {
      label: "Opción 1",
      value: "value1",
    },
    {
      label: "Opción 2",
      value: "value2",
    },
  ];
  
  const estatus = [
    {
      label: "Pagado",
      value: "pagado",
    },
    {
      label: "Pendiente",
      value: "pendiente",
    },
    {
      label: "Cancelado",
      value: "cancelado",
    },
  ];
  
  const ramos = [
    {
      label: "Ramo2",
      value: "Ramo2",
    },
    {
      label: "Ramo3",
      value: "Ramo3",
    },
  ];
  
  const divisas = [
    {
      label: "MXP",
      value: "MXP",
    },
    {
      label: "USX",
      value: "USX",
    },
  ];

  export {
    nombreCliente, estatus, ramos, divisas
  }